import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, LayoutGrid, Heart, ShoppingCart, User } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { useWishlist } from '@/store/dataStore';

const Item = ({ to, icon: Icon, label, badge, testid, end }) => (
  <NavLink to={to} end={end} data-testid={testid}
    className={({ isActive }) => `relative flex-1 flex flex-col items-center justify-center gap-0.5 h-full text-[10px] font-semibold transition-colors ${isActive ? 'text-[#F8D13F]' : 'text-white/75 active:text-white'}`}>
    <Icon size={21} />
    <span>{label}</span>
    {badge > 0 && <span className="absolute top-1.5 left-1/2 ml-2 min-w-[18px] h-[18px] px-1 rounded-full bg-[#F8D13F] text-[#1B2A4A] text-[10px] font-extrabold flex items-center justify-center">{badge}</span>}
  </NavLink>
);

// Phone-only bottom tab bar for the public shop.
export default function MobileBottomNav() {
  const { count, setIsOpen } = useCart();
  const { ids } = useWishlist();
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#1B2A4A] border-t border-white/10 pb-[env(safe-area-inset-bottom)]" data-testid="mobile-bottom-nav">
      <div className="flex h-16">
        <Item to="/" end icon={Home} label="Inicio" testid="mnav-home" />
        <Item to="/catalogo" icon={LayoutGrid} label="Catálogo" testid="mnav-catalog" />
        <Item to="/favoritos" icon={Heart} label="Favoritos" badge={ids.length} testid="mnav-favorites" />
        <button type="button" onClick={() => setIsOpen(true)} data-testid="mnav-cart"
          className="relative flex-1 flex flex-col items-center justify-center gap-0.5 text-[10px] font-semibold text-white/75 active:text-white">
          <ShoppingCart size={21} />
          <span>Carrito</span>
          {count > 0 && <span className="absolute top-1.5 left-1/2 ml-2 min-w-[18px] h-[18px] px-1 rounded-full bg-[#F8D13F] text-[#1B2A4A] text-[10px] font-extrabold flex items-center justify-center" data-testid="mnav-cart-count">{count}</span>}
        </button>
        <Item to="/mi-cuenta" icon={User} label="Cuenta" testid="mnav-account" />
      </div>
    </nav>
  );
}
